import MuiBreadcrumbs from '@mui/material/Breadcrumbs'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import TextComponent from '../TextComponent/TextComponent'
import styles from './BreadCrumbs.module.scss'

const SEGMENT_TRANSLATION_MAP: Record<string, string> = {
  dashboard: 'BREADCRUMBS.DASHBOARD',
  'menu-management': 'BREADCRUMBS.MENU',
  dishes: 'BREADCRUMBS.DISHES',
  toppings: 'BREADCRUMBS.TOPPINGS',
  ingredients: 'BREADCRUMBS.INGREDIENTS',
  'data-extraction': 'BREADCRUMBS.DATA_EXTRACTION',
  'employees-management': 'BREADCRUMBS.EMPLOYEES',
  'table-cards-management': 'BREADCRUMBS.TABLE_CARDS',
  'mobile-app-management': 'BREADCRUMBS.MOBILE_APP',
  feedback: 'BREADCRUMBS.FEEDBACK',
  'employees-schedule': 'BREADCRUMBS.SCHEDULE',
  'register-device': 'BREADCRUMBS.DEVICES',
  loyalty: 'BREADCRUMBS.LOYALTY',
  'floor-plan': 'BREADCRUMBS.FLOOR_PLAN',
  'sales-reports': 'BREADCRUMBS.SALES_REPORTS',
  // The reports section redirects to a child, so the crumb it lands on is
  // always one of these two, without them the trail stops at "Reports" and
  // never says which report is open.
  'menu-items': 'BREADCRUMBS.MENU_ITEMS',
  inventory: 'BREADCRUMBS.INVENTORY'
}

function Breadcrumbs() {
  const { t } = useTranslation()
  const location = useLocation()

  const segments = location.pathname.split('/').filter(Boolean)

  const translatedSegments = segments
    .map(segment => ({
      segment,
      translationKey: SEGMENT_TRANSLATION_MAP[segment]
    }))
    .filter(entry => entry.translationKey !== undefined)

  return (
    <MuiBreadcrumbs
      separator={
        <i
          className={`las la-angle-right icon-medium ${styles.breadCrumbsSeperator}`}
        />
      }
      aria-label="breadcrumb"
      sx={{
        display: 'flex',
        alignItems: 'flex-end',
        '.MuiBreadcrumbs-li': {
          display: 'flex'
        },
        '.MuiBreadcrumbs-separator': {
          margin: '0'
        }
      }}
    >
      <TextComponent
        key="home"
        text={t('BREADCRUMBS.HOME')}
        color="primary"
        uppercase
        fontSize="body-bold-medium"
      />
      {translatedSegments.map(({ segment, translationKey }, index) => {
        const isLast = index === translatedSegments.length - 1
        return (
          <TextComponent
            key={segment}
            text={t(translationKey)}
            color="primary"
            uppercase
            disabled={isLast}
            fontSize="body-bold-medium"
          />
        )
      })}
    </MuiBreadcrumbs>
  )
}

export default Breadcrumbs
